import mobileIOS from './mobileIOS'
import mobileAndroid from './mobileAndroid'

export default { mobileIOS , mobileAndroid } 

export const Icon_Preview = {
    mobileIOS , mobileAndroid
}